// header-click.directive.ts
import {
  Directive,
  ElementRef,
  Renderer2,
  Output,
  EventEmitter,
  AfterViewInit,
} from '@angular/core';

@Directive({
  selector: '[headerClick]',
})
export class HeaderClickDirective implements AfterViewInit {
  @Output() headerClicked = new EventEmitter<string>();

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit() {
    const headers = this.el.nativeElement.querySelectorAll('thead th');
    headers.forEach((th: HTMLElement) => {
      this.renderer.listen(th, 'click', () => {
        const title = th.innerText.trim();
        this.headerClicked.emit(title);
      });
    });
  }
}
